module.exports = __webpack_public_path__ + "static/HeroImage-9b004de610baaf39648d356f49a1d3e2.png";